import styled from 'styled-components/native'

export const IconListContainer = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

export const IconListIconCircle = styled.View<{ highlightcolor: string }>`
  height: 48px;
  width: 48px;
  border-radius: 24px;
  background-color: ${({ highlightcolor }) => highlightcolor}15;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 22px;
`

/**
 * OB-506: 16px to match ListCardTitle, so Punch Cards reads in the same
 * visual language as the adjacent menu rows. Color is driven by the
 * caller via `fontcolor`.
 */
export const IconListTitle = styled.Text<{ fontcolor: string }>`
  font-size: 16px;
  font-weight: bold;
  color: ${({ fontcolor }) => fontcolor};
`

export const IconListLine = styled.View<{ lineColor: string }>`
  border-bottom-width: 2px;
  border-bottom-color: ${({ lineColor }) => lineColor};
  margin: 4px 0;
`

/**
 * OB-506: 11px bottom margin matches CategoryHeading's bottom spacing on
 * the adjacent CategorySection-based rows (Workshops / Last minutes), so
 * Punch Cards visually lines up with them.
 */
export const IconListWrapper = styled.View`
  margin: 22px 0 11px 0;
`
